// extracted by mini-css-extract-plugin
export default {"releaseNotesPageContainer":"_release-notes-page_releaseNotesPageContainer__gPao3"};